module.exports = __webpack_public_path__ + "media/fonts/Roboto-Regular-d08b3cc873089fdba7fbf04e11611883.ttf";